import {
  Component,
  ElementRef,
  ViewChild,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  NgbDate,
  NgbModal,
  ModalDismissReasons,
} from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { pipe } from 'rxjs';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';
import { ProductService } from 'src/app/onelog/services/product.service';
import { ProductListService } from 'src/app/onelog/services/product-list.service';
import { SachLoginService } from 'src/app/onelog/services/sach-login.service';
import { environment } from 'src/environments/environment';
import { DEFAULT_DROP_DOWN_PISTATUS } from 'src/app/onelog/common/config/dropdown-config';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';

@Component({
  selector: 'app-published-report-page',
  templateUrl: './published-report-page.component.html',
  styleUrls: ['./published-report-page.component.css'],
})
export class PublishedReportPageComponent {
  //ProductListPageComponent
  title = 'Onelog';

  @ViewChild('mymodal') mymodal!: ElementRef;

  Products: any = [];
  ProductStatusList: any = [];
  selectedProduct: any = [];
  selectedStatus: string = '';
  postData: any = [];
  TokenData: any = [];
  showLoader: boolean = false;
  model: any;
  date: any;
  updatedDate: any = [];
  source: string = 'explorerPage';
  closeResult: string;
  modalValue: string;
  receivedDate: NgbDate;
  processingToastShow: boolean = false;
  successToastShow: boolean = false;
  apiURL = environment.sachWebURL;
  dropdownListProductType: any = [];
  dropdownSettingsProductType: IDropdownSettings = {};
  dropdownListBookType: any = [];
  dropdownSettingsBookType: IDropdownSettings = {};
  selectedProductType: any = [];
  selectedBookType: any = [];
  selectedproductId: string = '';
  responseData: any = [];
  piProductStatusList: any = [];
  listProductType: any = [];
  listBookType: any = [];
  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent: QueryList<DropDownSingleSelectComponent>;

  constructor(
    private productService: ProductService,
    private productStatus: ProductSatusService,
    private sachLoginService: SachLoginService,
    private productListService: ProductListService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.loadProducts();
    this.loadProductStatusList();
    //this.getSachToken();
    this.piProductStatusList = DEFAULT_DROP_DOWN_PISTATUS;
    this.listProductType = ['Video', 'Book', 'AudioBook'];
    this.listBookType = ['Normal', 'Mini', 'Maxi', 'Licensed'];

    this.dropdownListProductType = [
      { item_id: 1, item_text: 'Course' },
      { item_id: 2, item_text: 'Audio Book' },
      { item_id: 3, item_text: 'Video' },
      { item_id: 4, item_text: 'Book' },
    ];
    this.dropdownSettingsProductType = {
      idField: 'item_id',
      textField: 'item_text',
    };

    this.dropdownListBookType = [
      { item_id: 1, item_text: 'Normal' },
      { item_id: 2, item_text: 'Mini' },
      { item_id: 3, item_text: 'Maxi' },
      { item_id: 4, item_text: 'Licensed' },
    ];

    this.dropdownSettingsBookType = {
      idField: 'item_id',
      textField: 'item_text',
    };
  }
  // Get product list
  loadProducts(postdata: any = []) {
    return this.productService.getProducts(postdata).subscribe((data: {}) => {
      this.responseData = data;
      this.Products = this.responseData.data;
    });
  }

  loadProductStatusList() {
    return this.productStatus.getStatusList().subscribe((data: {}) => {
      this.ProductStatusList = data;
      //this.showLoader = false;
    });
  }

  getCheckboxValues(event: Event, product: any) {
    if (this.selectedProduct.includes(product.id)) {
      this.selectedProduct.splice(this.selectedProduct.indexOf(product.id), 1);
    } else {
      this.selectedProduct.push(product.id);
    }
  }

  getSelectedStatus(event: Event) {}

  onDateSelect(event: NgbDate) {}

  updateIepd(event: NgbDate) {
    this.receivedDate = event;
    this.open(this.mymodal);
  }

  submitStatus() {
    this.processingToastShow = true;
    this.postData = {
      source: this.source,
      productList: this.updatedDate,
      // 'productIds':this.selectedProduct
    };

    return this.productService
      .updateProductsDate(this.postData)
      .subscribe((data: {}) => {
        this.processingToastShow = false;
        this.successToastShow = true;
      });
  }

  searchProduct() {
    this.loadProducts({
      selectedBookType: this.selectedBookType,
      selectedProductType: this.selectedProductType,
      selectedproductId: this.selectedproductId,
    });
  }

  open(content: any): any {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
          return this.closeResult;
        },
        (reason) => {
          this.closeResult = `${this.getDismissReason(reason)}`;
          if (this.closeResult == 'save') {
            this.processRequest();
          }

          //return this.closeResult;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `${reason}`;
    }
  }

  processRequest() {
    this.updatedDate = this.productListService.updateData(this.receivedDate);
    this.submitStatus();
  }

  updateSelectedDropDown(event: Event) {
    const data: any = event;
    if (data.name == 'productType') {
      this.selectedProductType = [];
      this.selectedProductType.push(data.selectedOption);
    }

    if (data.name == 'bookType') {
      this.selectedBookType = [];
      this.selectedBookType.push(data.selectedOption);
    }
    //console.log(this.selectedProductType, this.selectedBookType)
  }

  updateStatus(event: any) {
    const data = event;
    const selectedId = data.selectedStatusId;
    this.receivedDate = event;
    this.open(this.mymodal);
  }

  updatePiStatus(event: any) {
    const data = event;
    const selectedPiStatus = data.selectedPiStatus;
    this.receivedDate = event;
    this.open(this.mymodal);
  }

  clearFilters() {
    this.clearAllDropDowns();
    this.selectedproductId = '';
    this.selectedBookType = [];
    this.selectedProductType = [];
  }

  clearAllDropDowns() {
    this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
      DropDownComp.clearInput();
    });
  }
}
